export const meta = {
  slug: { de: "online-arzttermin-vorteile-nachteile", en: "online-doctor-appointment-pros-cons" },
  title: "Online-Arzttermin: Vorteile, Grenzen und realistische Einordnung",
  excerpt:
    "Online-Termine entlasten viele Abläufe, sind aber kein Allheilmittel. Eine ruhige Abwägung hilft Patienten und Praxen, sie sinnvoll einzusetzen.",
  category: "einblicke",
  publishedAt: "2026-04-15",
  updatedAt: "2026-05-06",
  metaTitle: "Online Arzttermin – Vorteile und Grenzen | OnePractix",
  metaDescription:
    "Was Online-Arzttermine wirklich leisten – Vorteile, Grenzen und praktische Hinweise für Patienten und Praxen, die digital buchen oder vergeben.",
  related: ["facharzt-termin-wartezeit-verkuerzen", "online-terminbuchung-wann-sinnvoll"],
  en: {
    title: "Online doctor's appointment: benefits, limits and a realistic view",
    metaTitle: "Online doctor appointments: pros and cons | OnePractix",
    metaDescription:
      "Online doctor appointments: a calm look at the real benefits, the clear limits and practical guidance for patients and practices using digital booking.",
    excerpt:
      "Online appointments relieve many workflows but are not a cure-all. A calm assessment helps patients and practices use them sensibly.",
  },
};

export default meta;
